const recentActions = []

export const getRecentActions = () => {
  // negative number in `slice()` means take the last number items from end of array
  return JSON.stringify(recentActions.slice(-10))
}

export const actionHistory = store => next => action => {
  recentActions.push(action.type)
  return next(action)
}
